export function GuideShot({ img, box, caption, width = 150, testId, captionClass = "text-slate-300" }) {
  return (
    <div className="flex flex-col items-center" data-testid={testId}>
      <div className="relative" style={{ width }}>
        <img
          src={img}
          alt={caption || "инструкция"}
          loading="lazy"
          className="w-full rounded-xl border border-white/10"
        />
        <span
          className="guide-highlight"
          style={{ top: box.top, left: box.left, width: box.width, height: box.height }}
        />
      </div>
      {caption && (
        <div
          className={`text-xs ${captionClass} mt-2 text-center leading-snug`}
          style={{ maxWidth: width + 24 }}
        >
          {caption}
        </div>
      )}
    </div>
  );
}
